<template>

    <scrollactive
    activeClass="active"
    :offset="0"
    :duration="800"
    bezier-easing-value=".5,0,.35,1"
    class="nav-main d-none d-md-block">
        <a href="#page-1" class="scrollactive-item">Home</a>
        <a href="#page-2" class="scrollactive-item">Get Started</a>
        <a href="#page-3" class="scrollactive-item">Connectivity</a>
        <a href="#page-4" class="scrollactive-item">Themes</a>
        <a href="#page-5" class="scrollactive-item">Media Kit</a>
    </scrollactive>
</template>

<script>
    export default {
        data: function(){
            return {
            };
        }
    }
</script>


// WEBPACK FOOTER //
// Header.vue?100f846c